import http from './api'

export interface RestaurantTable {
  id: string
  restaurantId: string
  label: string
  qrToken: string
  seatsCount: number
  createdAt: string
}

class TableService {
  async listTables(restaurantId: string): Promise<RestaurantTable[]> {
    const response = await http.get(`/restaurants/${restaurantId}/tables`)
    return response.data
  }

  async createTable(restaurantId: string, data: { label: string; seatsCount?: number }): Promise<RestaurantTable> {
    const response = await http.post(`/restaurants/${restaurantId}/tables`, data)
    return response.data
  }

  async deleteTable(restaurantId: string, tableId: string): Promise<void> {
    await http.delete(`/restaurants/${restaurantId}/tables/${tableId}`)
  }

  getTableQrUrl(qrToken: string): string {
    const base = window.location.origin
    return `${base}/order-at-table/${qrToken}`
  }
}

const tableService = new TableService()
export default tableService
